<p-dialog [style]="{ width: '32rem' }" [breakpoints]="{ '575px': '90vw' }"
    [(visible)]="visibility" [closable]="false" [modal]="true" [draggable]="false" [dismissableMask]="true">

    <ng-template #header>
        <div class="ef-dialog-header">
            <span class="ef-dialog-title">{{ isEditMode ? 'Edit template' : 'New template' }}</span>
            <button class="ef-close-btn" type="button" (click)="cancel()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
    </ng-template>

    <form [formGroup]="form" class="ef-form" (ngSubmit)="submit()">

        <div class="ef-field">
            <label class="ef-label" for="tplName">Template name</label>
            <input id="tplName" formControlName="name" type="text" pInputText
                placeholder="e.g. Weekend Promo" class="ef-input" />
            @if ((form.get('name')?.touched || isSubmitted) && form.get('name')?.errors?.['required']) {
                <small class="ef-error">This field is required</small>
            }
        </div>

        <div class="ef-field">
            <span class="ef-label">Category</span>
            <div class="category-pills">
                @for (cat of categories; track cat.value) {
                <button type="button" class="cat-pill"
                    [class.selected]="form.get('category')?.value === cat.value"
                    (click)="selectCategory(cat.value)">
                    {{ cat.label }}
                </button>
                }
            </div>
        </div>

        <div class="ef-field">
            <label class="ef-label" for="tplTitle">Notification title</label>
            <input id="tplTitle" formControlName="title" type="text" pInputText
                placeholder="Enter notification title" class="ef-input" />
            @if ((form.get('title')?.touched || isSubmitted) && form.get('title')?.errors?.['required']) {
                <small class="ef-error">This field is required</small>
            }
        </div>

        <div class="ef-field">
            <div class="ef-label-row">
                <label class="ef-label" for="tplBody">Message body</label>
                <span class="ef-char-count">{{ bodyLength }} / 160</span>
            </div>
            <textarea id="tplBody" formControlName="body" pTextarea
                placeholder="Write the notification body..."
                class="ef-input ef-textarea" rows="4" [autoResize]="false"></textarea>
            @if ((form.get('body')?.touched || isSubmitted) && form.get('body')?.errors?.['required']) {
                <small class="ef-error">This field is required</small>
            }
        </div>

        @if (isEditMode) {
        <div class="tpl-preview">
            <div class="tpl-preview-app">
                <span class="tpl-preview-app-label">Yaldi · now</span>
                <p class="tpl-preview-title">{{ form.get('title')?.value || 'Notification title' }}</p>
                <p class="tpl-preview-body">{{ form.get('body')?.value || 'Notification body...' }}</p>
            </div>
        </div>
        }

    </form>

    <ng-template #footer>
        <div class="ef-dialog-footer">
            <p-button label="Cancel" variant="text" severity="secondary" size="small" (onClick)="cancel()" />
            <p-button [label]="isEditMode ? 'Save changes' : 'Create template'"
                [icon]="isEditMode ? '' : 'fa-solid fa-plus'"
                [loading]="loading" severity="primary" size="small" (onClick)="submit()" />
        </div>
    </ng-template>

</p-dialog>
